export default __webpack_public_path__ + "static/media/PAFI_Annual Report 2020.ae338786.pdf";